import { Grid, Cell } from 'components/Grid';
import styles from './productSection.scss';
import { NO_ELEMENT, hasElements } from 'utils';
import { Section } from 'components/Section';
import { isMobile, isTabletLayout } from 'components/Shared/responsive';
import { ProductCard } from 'components/Shared/Product/themes/BGH/productCard';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { useSelector } from 'react-redux';
import { ListViewProduct } from 'models/ListViewProduct';
import { SetElementProps } from 'hooks/useIntersectionObserver';

const MOBILE_WIDTH = 181;
const DESKTOP_WIDTH = 282;
const IMAGE_MARGIN = 2;

const picture = {
  height: DESKTOP_WIDTH + IMAGE_MARGIN,
  width: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

interface GetNumberOfProductsProps {
  isMobile: boolean;
  isTablet: boolean;
}
const getAmountOfProducts = ({ isMobile, isTablet }: GetNumberOfProductsProps): number => {
  const AMOUNT_OF_PRODUCTS_MOBILE = 2;
  const AMOUNT_OF_PRODUCTS_TABLET = 3;
  const AMOUNT_OF_PRODUCTS_DESKTOP = 5;

  if (isMobile) {
    return AMOUNT_OF_PRODUCTS_MOBILE;
  }

  if (isTablet) {
    return AMOUNT_OF_PRODUCTS_TABLET;
  }

  return AMOUNT_OF_PRODUCTS_DESKTOP;
};

const useSizes = () => {
  const _isMobile = useSelector(isMobile);
  const _isTablet = useSelector(isTabletLayout);

  return {
    isMobile: _isMobile,
    isTablet: _isTablet
  };
};

interface ProductSectionProps {
  title: string;
  products: ListViewProduct[];
  onClick?: (product: ProductlistViewProduct, index: number) => void;
  setIntersectObserverRef: (props: SetElementProps<ListViewProduct>) => void;
}

export const ProductSection = ({
  products,
  title,
  onClick,
  setIntersectObserverRef
}: ProductSectionProps) => {
  const { isMobile, isTablet } = useSizes();

  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  const amountOfProducts = getAmountOfProducts({ isMobile, isTablet });

  const content = products
    .slice(0, amountOfProducts)
    .map((product: ProductlistViewProduct, index) => (
      <Cell
        ref={node => setIntersectObserverRef({ ref: node, payload: product })}
        key={product.title}
      >
        <ProductCard
          isCategoryBold
          {...product}
          picture={picture}
          customSizes={sizes}
          onLinkClick={() => onClick && onClick(product, index)}
        />
      </Cell>
    ));

  return (
    <Section title={title} className={styles.section}>
      <Grid
        huge="5"
        tablet="3"
        desktop="4"
        phone="2"
        gutters="large"
        className={styles.gridStyling}
      >
        {content}
      </Grid>
    </Section>
  );
};
